/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from "three";
import React, { useMemo } from "react";
import { const_var, params } from "../../../../../../redux/reducers/reducer";
import { extrudeSettings, leanRoofLoftTrimModel } from "../../../../../../utils/Functions";
import { useState } from "react";
import { controls } from "../../../../../../redux/reducers/common/eventReducer";
import { MaterialTrim } from "../../../../CustomMaterial";


const TrimModel = () => {
    const [isEqualLeftHeight, setIsEqualLeftHeight] = useState(false);
    const [isEqualRightHeight, setIsEqualRightHeight] = useState(false);
    const [isEqualHeight, setIsEqualHeight] = useState(false);
    const [isEqualLeftLeanHeight, setIsEqualLeftLeanHeight] = useState(false);
    const [isEqualRightLeanHeight, setIsEqualRightLeanHeight] = useState(false);
    const [isAction, setIsAction] = useState(false);
    // const [angle, setAngle] = useState(Math.atan(params.b_l_t_r_pF / 12));
    // const [roofWidthSize, setRoofWidthSize] = useState(Math.sqrt(Math.pow(params.leanF_p_w, 2) + Math.pow((params.leanF_p_w / 12) * params.b_l_t_r_pF, 2)));
    const [overHangLength, setOverHangLength] = useState(0);
    const trimThickness = (params.p_r_s === 1) ? 0.2 : 0.1;
    const cbFrontBackWallOffset = 0.16;

    const trimOffsetHeight = params.p_r_p / 12 * 0.2;    
    const leanRoofLeftHeight = params.b_l_t_r_p / 12 * params.lean_p_w;
    const leanRoofRightHeight = params.b_l_t_r_pR / 12 * params.leanR_p_w;
    const leanRoofHeight = (params.b_l_t_r_pF / 12) * params.leanF_p_w;
  
    const leftOffsetValue = useMemo(() => (
        (isEqualLeftLeanHeight && !isEqualRightLeanHeight && (params.p_w === params.leanF_p_d || Number(params.leantoAlignmentFront) === 2)) ||
        (isEqualLeftLeanHeight && isEqualRightLeanHeight && (params.p_w !== params.leanF_p_d && Number(params.leantoAlignmentFront) === 2)) ||
        (isEqualLeftLeanHeight && isEqualRightLeanHeight && (params.p_w === params.leanF_p_d))
      ) ? 0.53 : 0, [isEqualLeftLeanHeight, isEqualRightLeanHeight, isEqualHeight, params.p_w, params.leanF_p_d, params.leantoAlignmentFront]);
      
      const rightOffsetValue = useMemo(() => (
        (!isEqualLeftLeanHeight && isEqualRightLeanHeight && (params.p_w === params.leanF_p_d || Number(params.leantoAlignmentFront) === 3)) ||
        (isEqualLeftLeanHeight && isEqualRightLeanHeight && (params.p_w !== params.leanF_p_d && Number(params.leantoAlignmentFront) === 3)) ||
        (isEqualLeftLeanHeight && isEqualRightLeanHeight && (params.p_w === params.leanF_p_d))
      ) ? 0.53 : 0, [isEqualLeftLeanHeight, isEqualRightLeanHeight, isEqualHeight, params.p_w, params.leanF_p_d, params.leantoAlignmentFront]);

    const roofSideTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-0.07, (-0.07 * params.b_l_t_r_pF) / 12);
        model.lineTo(params.leanF_p_w - (isAction && trimThickness), (params.b_l_t_r_pF / 12) * params.leanF_p_w - (isAction && trimOffsetHeight));
        model.lineTo(
            params.leanF_p_w - (isAction && trimThickness),
            (params.b_l_t_r_pF / 12) * params.leanF_p_w - (isAction && trimOffsetHeight) - 0.2
        );
        model.lineTo(-0.07, (-0.07 * params.b_l_t_r_pF) / 12 - 0.2);
        model.closePath();

        return model;
    }, [params.b_l_t_r_pF, params.leanF_p_w, isAction]);

    const roofFrontTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        model.moveTo(-0.02, (-params.b_l_t_r_pF / 12) * 0.02);
        model.lineTo(0.05, (params.b_l_t_r_pF / 12) * 0.1);
        model.lineTo(0.05, (params.b_l_t_r_pF / 12) * 0.1 - 0.2);
        model.lineTo(-0.02, (-params.b_l_t_r_pF / 12) * 0.02 - 0.2);
        model.closePath();

        return model;
    }, [params.b_l_t_r_pF]);

    const roofFrontTrimLength = useMemo(() => {
        let length;

        if (params.add_left_front_lean_porch !== true && params.add_right_front_lean_porch !== true) {
            length = params.leanF_p_d + 0.04;
        } else if (
            (params.add_left_front_lean_porch !== true && params.add_right_front_lean_porch === true) ||
            (params.add_left_front_lean_porch === true && params.add_right_front_lean_porch !== true)
        ) {
            length = params.leanF_p_d + params.leanF_p_w + 0.04;
        } else {
            length = params.leanF_p_d + 2 * params.leanF_p_w + 0.04;
        }
        return length;
    }, [params.add_left_front_lean_porch, params.add_right_front_lean_porch, params.leanF_p_d, params.leanF_p_w]);

    const roofFrontTrimPosX = useMemo(() => {
        if (params.add_left_front_lean_porch === true && params.add_right_front_lean_porch === true) {
            return -roofFrontTrimLength / 2;
        } else if (params.add_left_front_lean_porch === true && params.add_right_front_lean_porch !== true) {
            return -roofFrontTrimLength / 2 - params.leanF_p_w / 2;
        } else if (params.add_left_front_lean_porch !== true && params.add_right_front_lean_porch === true) {
            return -roofFrontTrimLength / 2 + params.leanF_p_w / 2;
        } else {
            return -roofFrontTrimLength / 2;
        }
    }, [params.add_left_front_lean_porch, params.add_right_front_lean_porch, params.leanF_p_w, roofFrontTrimLength]);

    useMemo(() => {
        if (params.p_h === leanRoofLeftHeight + params.lean_p_h) {
            setIsEqualLeftHeight(true);
        } else {
            setIsEqualLeftHeight(false);
        }
        if (params.p_h === leanRoofRightHeight + params.leanR_p_h) {
            setIsEqualRightHeight(true);
        } else {
            setIsEqualRightHeight(false);
        }
        if(params.p_h === leanRoofHeight + params.leanF_p_h) setIsEqualHeight(true);   
        else setIsEqualHeight(false)
        if(params.add_left_lean && (leanRoofHeight + params.leanF_p_h === leanRoofLeftHeight + params.lean_p_h) && ((params.p_d === params.lean_p_d) || Number(params.leantoAlignmentLeft) === 2))
         setIsEqualLeftLeanHeight(true);
        else setIsEqualLeftLeanHeight(false)
        if(params.add_right_lean && (leanRoofHeight + params.leanF_p_h === leanRoofRightHeight + params.leanR_p_h) && ((params.p_d === params.leanR_p_d) || Number(params.leantoAlignmentRight) === 2))
         setIsEqualRightLeanHeight(true);
        else setIsEqualRightLeanHeight(false)
    }, [params.p_h, params.lean_p_h, params.leanR_p_h, leanRoofLeftHeight, leanRoofRightHeight, leanRoofHeight, params.b_l_t_r_p, params.b_l_t_r_pF, params.leantoAlignmentLeft, params.leantoAlignmentRight, params.b_l_t_r_pR, params.leanF_p_h, params.add_left_lean, params.add_right_lean, params.p_d, params.lean_p_d, params.leanR_p_d ])

    useMemo(() => {
        if (isEqualLeftHeight && params.add_left_front_lean_porch) {
            // setAngle(Math.atan((leanRoofLeftHeight - trimOffsetHeight) / (params.leanF_p_w - trimThickness)));
            // setRoofWidthSize(params.leanF_p_w / Math.cos(angle));
            setIsAction(true);
        } else if (isEqualRightHeight && params.add_right_front_lean_porch) {
            // setAngle(Math.atan((leanRoofRightHeight - trimOffsetHeight) / (params.leanF_p_w - trimThickness)));
            // setRoofWidthSize(params.leanF_p_w / Math.cos(angle));
            setIsAction(true);
        } else {
            // setAngle(Math.atan(params.b_l_t_r_pF / 12));
            // setRoofWidthSize(Math.sqrt(Math.pow(params.leanF_p_w, 2) + Math.pow((params.leanF_p_w / 12) * params.b_l_t_r_pF, 2)));
            setIsAction(false);
        }
    }, [isEqualLeftHeight, isEqualRightHeight, leanRoofLeftHeight, leanRoofRightHeight, trimOffsetHeight, params.add_left_front_lean_porch, params.add_right_front_lean_porch, params.b_l_t_r_pF, params.leanF_p_w]);

    useMemo(() => {
        if (params.p_r_s === 2 || params.p_r_s === 1) {
            if(params.p_r_s === 2) setOverHangLength(0.75); else setOverHangLength(0.75);

        } else if (params.p_r_s === 3) {

            if (params.o_v_h_n_g_e === true) {
                setOverHangLength(0.9)
            } else {
                setOverHangLength(0.75)
            }
        }
    }, [params.p_r_s, params.o_v_h_n_g_e])

    return (
        <>
            { !params.add_left_front_lean_porch && 
                ( params.p_r_s === 1 ?
                    <mesh name='loft-roof-trim-left' position={[-(params.leanF_p_d / 2 + overHangLength + 0.01) + leftOffsetValue + 0.15, params.leanF_p_h - 0.05, params.p_d / 2 + params.leanF_p_w + 0.23]} rotation={[0, Math.PI / 2, 0]}>
                        <extrudeGeometry args={[leanRoofLoftTrimModel(params.b_l_t_r_pF, params.leanF_p_w + 0.1), extrudeSettings(trimThickness)]} />
                        <MaterialTrim visibleSection={"frontLean"} />
                    </mesh>
                    :
                    <mesh name='non-loft-roof-trim-left' position={[-(params.leanF_p_d / 2 + trimThickness), params.leanF_p_h, params.p_d / 2 + params.leanF_p_w + cbFrontBackWallOffset]} rotation={[0, Math.PI / 2, 0]}>
                        <extrudeGeometry args={[roofSideTrimModel, extrudeSettings(trimThickness)]} />
                        <MaterialTrim visibleSection={"frontLean"} />
                    </mesh>
                )
            }
            { !params.add_right_front_lean_porch &&
                ( params.p_r_s === 1 ? 
                    <mesh name='loft-roof-trim-right' position={[(params.leanF_p_d / 2 + overHangLength - 0.15) - rightOffsetValue - 0.15, params.leanF_p_h - 0.05, params.p_d / 2 + params.leanF_p_w + 0.23]} rotation={[0, Math.PI / 2, 0]}>
                        <extrudeGeometry args={[leanRoofLoftTrimModel(params.b_l_t_r_pF, params.leanF_p_w + 0.1), extrudeSettings(trimThickness)]} />
                        <MaterialTrim visibleSection={"frontLean"} />
                    </mesh>
                    :
                    <mesh name='non-loft-roof-trim-right' position={[(params.leanF_p_d / 2  - trimThickness/6), params.leanF_p_h, params.p_d / 2 + params.leanF_p_w + cbFrontBackWallOffset]} rotation={[0, Math.PI / 2, 0]}>
                        <extrudeGeometry args={[roofSideTrimModel, extrudeSettings(trimThickness)]} />
                        <MaterialTrim visibleSection={"frontLean"} />
                    </mesh>
                )
            }
            { params.p_r_s !== 1 && (
                <mesh name='non-loft-roof-trim-front' position={[roofFrontTrimPosX, params.leanF_p_h - 0.05 * (params.b_l_t_r_pF / 12), params.p_d / 2 + params.leanF_p_w + cbFrontBackWallOffset + 0.05]} rotation={[0, Math.PI / 2, 0]}>
                    <extrudeGeometry args={[roofFrontTrimModel, extrudeSettings(roofFrontTrimLength)]} />
                    <MaterialTrim visibleSection={"frontLean"} />
                </mesh>
            )}
        </>
    );
};

export default TrimModel;